import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["data-selected"]
const _hoisted_2 = ["type", "name", "value", "checked", "disabled"]
const _hoisted_3 = { class: "flex min-w-0 flex-grow flex-col gap-1" }
const _hoisted_4 = {
  "data-option-title": "",
  class: "text-[15px] font-semibold text-gray-900"
}
const _hoisted_5 = {
  key: 0,
  class: "text-sm leading-normal text-gray-600"
}
const _hoisted_6 = {
  key: 1,
  "data-chip": "",
  class: "mt-1.5 self-start rounded-full bg-[#eff6ff] px-[9px] py-[3px] text-xs font-medium text-[#1d4ed8]"
}
const _hoisted_7 = {
  key: 1,
  "data-indicator": "radio-on",
  class: "box-border h-[22px] w-[22px] flex-shrink-0 rounded-full border-[6px] border-gray-900 bg-white"
}
const _hoisted_8 = {
  key: 2,
  "data-indicator": "checked",
  class: "flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full bg-gray-900 text-white"
}
const _hoisted_9 = {
  key: 3,
  "data-indicator": "off",
  class: "box-border h-[22px] w-[22px] flex-shrink-0 rounded-full border-[1.5px] border-gray-300"
}

import WizardIcon from '@/components/neue/wizard/WizardIcon.vue'


export default {
  __name: 'SelectionCard',
  props: {
  selected: { type: Boolean, default: false },
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  chip: { type: String, default: '' },
  icon: { type: String, default: '' },
  mode: { type: String, default: 'radio' },
  name: { type: String, default: '' },
  value: { type: String, default: undefined },
  compact: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
},
  emits: ['select'],
  setup(__props) {




return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("label", {
    "data-option": "",
    "data-selected": String(__props.selected),
    class: _normalizeClass(["relative flex items-start rounded-xl border bg-white text-left transition-all duration-200 ease-out has-[:focus-visible]:outline has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-gray-900", [
      __props.compact ? 'gap-3 px-[18px] py-3.5' : 'gap-4 px-5 py-[18px]',
      __props.selected
        ? 'border-gray-900 shadow-[0_0_0_4px_rgba(17,24,39,0.06),0_12px_28px_-10px_rgba(17,24,39,0.28),0_2px_6px_-2px_rgba(17,24,39,0.12)]'
        : 'border-gray-200 shadow-[0_1px_2px_rgba(15,23,34,0.04),0_2px_8px_-4px_rgba(15,23,34,0.06)] hover:-translate-y-px hover:border-gray-300 hover:shadow-[0_1px_2px_rgba(15,23,34,0.04),0_10px_24px_-10px_rgba(15,23,34,0.18)]',
      __props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
    ]])
  }, [
    _createElementVNode("input", {
      type: __props.mode === 'radio' ? 'radio' : 'checkbox',
      class: "sr-only",
      name: __props.name || undefined,
      value: __props.value,
      checked: __props.selected,
      disabled: __props.disabled,
      onChange: _cache[0] || (_cache[0] = $event => (_ctx.$emit('select')))
    }, null, 40, _hoisted_2),
    (__props.icon && !__props.compact)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          "data-icon-tile": "",
          class: _normalizeClass(["flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[10px]", __props.selected ? 'bg-gray-900 text-white' : 'bg-[#f1f3f6] text-gray-600'])
        }, [
          _createVNode(WizardIcon, { name: __props.icon }, null, 8, ["name"])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1),
      (__props.subtitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.subtitle), 1))
        : _createCommentVNode("", true),
      (__props.chip)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.chip), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.selected && __props.mode === 'radio')
      ? (_openBlock(), _createElementBlock("span", _hoisted_7))
      : (__props.selected)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              width: "12",
              height: "12",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "3.5",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", {
                d: "M5 12l5 5L20 7",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]))]))
        : (_openBlock(), _createElementBlock("span", _hoisted_9))
  ], 10, _hoisted_1))
}
}

}